import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { toast } from "sonner";
import { getMyProfile, updateMyProfile } from "@/lib/api/portal.functions";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authenticated/portal/profile")({
  component: ProfilePage,
});

function ProfilePage() {
  const fetchProfile = useServerFn(getMyProfile);
  const save = useServerFn(updateMyProfile);
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ["my-profile"],
    queryFn: () => fetchProfile(),
  });
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (data?.profile) {
      setFullName(data.profile.full_name ?? "");
      setPhone(data.profile.phone ?? "");
    }
  }, [data]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      await save({ data: { full_name: fullName, phone } });
      toast.success("Profile updated");
      qc.invalidateQueries({ queryKey: ["my-profile"] });
    } catch (err: any) {
      toast.error("Could not save", { description: err?.message });
    } finally {
      setSaving(false);
    }
  }

  return (
    <section>
      <h2 className="mb-4 font-display text-xl text-navy">Profile</h2>
      <form onSubmit={onSubmit} className="max-w-md space-y-4 rounded-lg border border-border bg-card p-6">
        <div>
          <Label>Email</Label>
          <Input value={data?.profile?.email ?? ""} disabled />
        </div>
        <div>
          <Label htmlFor="full_name">Full name</Label>
          <Input id="full_name" value={fullName} onChange={(e) => setFullName(e.target.value)} required />
        </div>
        <div>
          <Label htmlFor="phone">Phone</Label>
          <Input id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="071 276 6198" />
        </div>
        <Button type="submit" disabled={saving} className="bg-navy hover:bg-navy/90">
          {saving ? "Saving…" : "Save changes"}
        </Button>
      </form>
    </section>
  );
}
